import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import { definitionFor, isSourceDeclarationKey, sortDeclarations } from '../utils/declarations';
export default class DeclarationList extends Component {
  view(vnode) {
    const validDeclarations = sortDeclarations(vnode.attrs.declarations.filter(declaration => definitionFor(declaration.key())));
    const hasOtherDeclarations = validDeclarations.some(declaration => !isSourceDeclarationKey(declaration.key()));
    if (!hasOtherDeclarations) return null;
    const labels = validDeclarations.map(declaration => {
      const key = declaration.key();
      if (['original', 'reference', 'personal_opinion'].includes(key)) {
        return app.translator.trans(`ffans-creator-declarations.forum.display.${key}_summary`, {}, true);
      }
      return app.translator.trans(`ffans-creator-declarations.lib.declarations.${declaration.key()}.label`, {}, true);
    });
    return m("section", {
      className: "CreatorDeclarations"
    }, m("button", {
      type: "button",
      className: "CreatorDeclarations-summary",
      "aria-label": app.translator.trans('ffans-creator-declarations.forum.display.open_details', {}, true),
      onclick: () => {
        app.modal.show(() => import(/* webpackChunkName: 'forum/components/DeclarationInfoModal', webpackMode: 'lazy-once' */ './DeclarationInfoModal'), {
          declarations: validDeclarations
        });
      }
    }, m(Icon, {
      name: "fas fa-bullhorn",
      className: "CreatorDeclarations-icon"
    }), m("span", {
      className: "CreatorDeclarations-format"
    }, app.translator.trans('ffans-creator-declarations.forum.display.declaration_format', {
      declarations: labels.join(app.translator.trans('ffans-creator-declarations.forum.display.declaration_separator', {}, true))
    })), m("span", {
      className: "CreatorDeclarations-more",
      "aria-hidden": "true"
    }, m(Icon, {
      name: "fas fa-chevron-right"
    }))));
  }
}
flarum.reg.add('ffans-creator-declarations', 'forum/components/DeclarationList', DeclarationList);flarum.reg.addChunkModule('883', '657', 'ffans-creator-declarations', 'forum/components/DeclarationInfoModal');